/**
 * Is this page being served from the developer's own machine?
 *
 * Deliberately a runtime hostname check rather than `import.meta.env.DEV`.
 * The build mode travels with the bundle, so a dev build served from anywhere —
 * a preview deploy, a tunnel, a colleague's laptop — still reports DEV and
 * would show developer chrome to a client. Where the page is actually being
 * read from is the thing we care about.
 *
 * Note this is false over a LAN IP, which is how a phone reaches a local dev
 * server. That is the trade: it also means nothing leaks onto a shared URL.
 * Widen it to private ranges if on-device testing needs the chrome.
 */
export function isLocalHost(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1' || host === '::1' || host === '[::1]';
}
